var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleSwitch',{attrs:{"label":"Preview Mode","value":_vm.isPreviewMode},on:{"input":_vm.handlePreviewModeChange}})}
var staticRenderFns = []

export { render, staticRenderFns }